import React, { useEffect, useRef, type FC } from 'react';
import { styled, TextField, type TextFieldProps } from '@mui/material';

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  '& .MuiOutlinedInput-input': {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px',
    borderColor: theme.palette.action.disabled,
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.action.hover,
  },
  '& .MuiInputLabel-root': {
    fontWeight: 500,
    color: theme.palette.text.disabled,
  },
  '& .MuiInputLabel-root.Mui-focused': { fontWeight: 600 },
  '& .MuiSvgIcon-root': { color: theme.palette.text.disabled },
}));

const AppTextField: FC<TextFieldProps> = (props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const inputElement = inputRef.current;
    if (inputElement instanceof HTMLElement) {
      const handleWheel = (e: WheelEvent) => {
        // Prevent the wheel event from changing the input value
        e.preventDefault();
      };

      inputElement.addEventListener('wheel', handleWheel, { passive: false });
      return () => {
        inputElement.removeEventListener('wheel', handleWheel);
      };
    }
  }, []);

  return (
    <StyledTextField
      {...props}
      inputRef={inputRef}
      inputProps={{
        ...props.inputProps,
      }}
    />
  );
};

export default AppTextField;
